import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import {
  GET_SERVICE_CHANGE_CRITERIA_FULFILLED,
  GET_SERVICE_CHANGE_CRITERIA_PENDING,
  GET_SERVICE_CHANGE_CRITERIA_FAILED,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"
import { urls } from "utils-lib/builds"
import { MOCK_SERVICE_CHANGE_INFORMATION } from "utils-lib/mocks"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

const CLOUDCRAZE_REFRESH_TOKEN = `_khEtXW82qn8LZVAzSQD1vnE7fmy86uBD0yBI41i7_k`

export const pendingAC = () => ({
  type: GET_SERVICE_CHANGE_CRITERIA_PENDING,
})

export const failedAC = () => ({
  type: GET_SERVICE_CHANGE_CRITERIA_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_SERVICE_CHANGE_CRITERIA_FULFILLED,
  payload: data,
})

export const getServiceChangeCriteria =
  (customerId, payload) => (dispatch, getState) => {
    const api = `SERVICE_CHANGE_RECOMMENDATIONS`
    const template = URITemplate(urls.url[api])
    const state = getState()
    const locale = get(state, `siteLanguage.language`, ``)

    let mockJsonFile
    if (payload?.changeDuration) {
      if (payload?.changeDuration === "R")
        mockJsonFile = `${ssrWindow.origin}/mock/permanent-edit-service-change-criteria-response.json`
      else
        mockJsonFile = `${ssrWindow.origin}/mock/temporary-edit-service-change-criteria-response.json`
    } else
      mockJsonFile = `${ssrWindow.origin}/mock/add-service-change-criteria-response.json`
    const url = MOCK_SERVICE_CHANGE_INFORMATION
      ? mockJsonFile
      : template.expand({
          customerId,
          userId: get(state, `userAccount.userDetails.userId`, ``),
          lang: locale,
        })

    const data = {
      ...payload,
    }

    const config = {
      method: MOCK_SERVICE_CHANGE_INFORMATION ? `GET` : `POST`,
      headers: {},
      data,
    }

    return getTokenAction(dispatch, getState).then(async (res) => {
      config.headers.oktaToken = res.accessToken
      config.headers.apiKey = get(urls, `apiKey.USER[${api}]`, ``)
      config.headers.refreshToken = CLOUDCRAZE_REFRESH_TOKEN
      return getServiceChangeCriteriaHelper(url, config, dispatch)
    })
  }

export const getServiceChangeCriteriaHelper = (url, config, dispatch) => {
  dispatch(pendingAC())

  return axios(url, config)
    .then((response) => {
      dispatch(fulfilledAC(response.data.data))
      return response.data.data
    })
    .catch(() => {
      dispatch(failedAC())
    })
}
